import React from 'react';
import FadeoutErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';

export default class CampaignCategoryInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            deletingError: false,
            errorMessage: ''
        };
    }

    showModal() {
        if (this.state.deletingError || this.state.errorMessage) this.setState({ deletingError: false, errorMessage: '' });
        this.props.showModal();
    }

    async deleteSetting(id) {
        if (this.state.deletingError || this.state.errorMessage) this.setState({ deletingError: false, errorMessage: '' });
        await this.props.delete(id);
        if (this.props.deleting[id] && !this.props.deleting[id].success) {
            if (this.props.deleting[id] && this.props.deleting[id].message) this.setState({ errorMessage: this.props.deleting[id].message });
            else this.setState({ deletingError: true });
        }
    }

    render() {
        const { campaignCategories } = this.props;
        return (
            <div>
                <div className="flex-justify flex-center signature-label">
                    <label className="input-label">Campaign Categories</label>
                    <a className="link-text xs-text" onClick={this.showModal.bind(this)}>Add New</a>
                </div>
                <div className="chip-container">
                    {campaignCategories.map((category, index) =>
                        <div className="chip" key={index}>
                            <span>{category.name} - {category.campaignType}</span>
                            {(this.props.deleting[category.campaignCategoryId] && this.props.deleting[category.campaignCategoryId].loading) ? <LoadingSpinner loading={this.props.deleting[category.campaignCategoryId] && this.props.deleting[category.campaignCategoryId].success} />
                                : <i className="material-icons delete-chip" onClick={this.deleteSetting.bind(this, category.campaignCategoryId)}>close</i>}
                        </div>
                    )}
                </div>
                <FadeoutErrorMessage show={this.state.deletingError || this.state.errorMessage} message={this.state.errorMessage || "Could not delete setting"} timeOut={5000}/>
            </div>
        );

    }
}

//campaignCategories, delete, showModal, deleting (adding is shown on modal)....


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/campaignSettings/CampaignCategoryInput.jsx